import { render } from "./MultiPageImage.vue?vue&type=template&id=fb70c08a"
import script from "./MultiPageImage.vue?vue&type=script&lang=js"
export * from "./MultiPageImage.vue?vue&type=script&lang=js"

import "./MultiPageImage.vue?vue&type=style&index=0&id=fb70c08a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__